import React, { createContext, useContext, useState, useEffect } from "react";

type Theme = "warm" | "cool";

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: "cool", // Default to Sci-Fi/Cool
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = localStorage.getItem("app-theme");
    return (saved as Theme) || "cool";
  });

  useEffect(() => {
    localStorage.setItem("app-theme", theme);
    // Update body class for global background color
    document.body.className = theme === "cool" ? "bg-slate-900 text-white" : "bg-amber-50 text-gray-900";
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "warm" ? "cool" : "warm"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};